import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { XCircle, ArrowLeft, HelpCircle } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <div className="py-12">
      <div className="max-w-md mx-auto px-4">
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-8 h-8 text-muted-foreground" />
          </div>
          <h1 className="text-2xl font-bold mb-2">Payment Cancelled</h1>
          <p className="text-muted-foreground">
            No worries — you haven't been charged. Your assessment results are still saved.
          </p>
        </div>

        <Card className="mb-8">
          <CardContent className="p-6">
            <h2 className="font-semibold mb-3">Why upgrade to Pro?</h2>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>• Get a tailored business plan you can share with investors</li>
              <li>• Track your progress with 30-day action plans</li>
              <li>• See your FoundrScore improve over time</li>
              <li>• PDF exports for all your plans and canvases</li>
            </ul>
          </CardContent>
        </Card>

        <div className="space-y-3">
          <Link to="/pricing" className="block">
            <Button className="w-full rounded-full" data-testid="view-pricing-btn">
              View Pricing Options
            </Button>
          </Link>
          <Link to="/hub" className="block">
            <Button variant="outline" className="w-full rounded-full">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Validation Hub
            </Button>
          </Link>
        </div>

        <div className="mt-8 p-4 bg-muted/50 rounded-lg">
          <div className="flex items-start gap-3">
            <HelpCircle className="w-5 h-5 text-muted-foreground flex-shrink-0 mt-0.5" />
            <div className="text-sm">
              <p className="font-medium mb-1">Have questions?</p>
              <p className="text-muted-foreground">
                Not sure if Pro is right for you?{" "}
                <a 
                  href="https://calendly.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-primary underline"
                >
                  Book a free 15-minute call
                </a>{" "}
                to discuss your business idea.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
